<script setup lang="ts">
import type { StrapiFile } from '@/models'
import { Carousel, Slide } from 'vue3-carousel'
import 'vue3-carousel/carousel.css'

const props = defineProps<{
  mediaList: StrapiFile[]
  config?: Record<string, unknown>
  customClass?: string
}>()

const isWrapAround = props.config?.wrapAround
</script>

<template>
  <div
    v-if="mediaList.length"
    class="flex flex-col items-center justify-center"
    :class="{ 'w-full': isWrapAround }"
  >
    <Carousel v-bind="config" :class="customClass">
      <Slide v-for="(media, i) in mediaList" :key="media.id" :style="{ '--bg-index': (i % 5) + 1 }">
        <div class="h-full flex flex-col items-center justify-center">
          <video v-if="media.mime.includes('video')" :src="media.url" muted />
          <img class="w-full" v-else-if="media.mime.includes('image')" :src="media.url" alt="" />
        </div>
      </Slide>
    </Carousel>
  </div>
</template>
